import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { CustomCell } from '../../components/custom-cell';

export const TABLE_COLUMNS = [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Производитель',
		field: 'partner',
		flex: 2,
		filterOperators: getStringOperators(),
		valueFormatter: value => {
			if (!value) {
				return '';
			}

			return value.name;
		},
	},
	{
		headerName: 'Внеш. Д, см',
		field: 'outer_length',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внеш. Ш, см',
		field: 'outer_width',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внеш. В, см',
		field: 'outer_height',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внеш. объем, м³',
		field: 'outer_volume',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. Д, см',
		field: 'inner_length',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. Ш, см',
		field: 'inner_width',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. В, см',
		field: 'inner_height',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Внут. объем, м³',
		field: 'inner_volume',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Масса пустого, кг',
		field: 'empty_weight',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Общ. высота, см',
		field: 'total_height',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Общ. масса, кг',
		field: 'total_weight',
		flex: 2,
		align: 'center',
		headerAlign: 'center',
		filterOperators: getNumericOperators(),
	},
];

export const NAV_PAGE_LIST = [
	{ text: 'Термоконтейнеры', href: '/thermoboxes' },
	{ text: 'Хладоэлементы', href: '/icepacks' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
